import { Box } from '@mui/material';
import { EstadoAvisoObraEnum } from '../../AvisoObra/consts/avisoObraStatesTypes';
import { TranslateFunction } from '../../../hooks/useTranslate';

export enum BatchesStatesEnum {
    PENDIENTE = 1,
    EN_CURSO = 2,
    CERRADO = 3
}

export enum BatchesTabsEnumStrings {
    PENDIENTE = 'Pendiente',
    EN_CURSO = 'En Curso',
    CERRADO = 'Cerrado'
}

export const getBatchStateLabel = (estado: BatchesTabsEnumStrings, t: TranslateFunction): string => {
    switch (estado) {
        case BatchesTabsEnumStrings.PENDIENTE:
            return t('batches.states.pending');
        case BatchesTabsEnumStrings.EN_CURSO:
            return t('batches.states.inProgress');
        case BatchesTabsEnumStrings.CERRADO:
            return t('batches.states.closed');
        default:
            return t('batches.states.unknown');
    }
};

export const BatchesStateBadge = ({ state, t }: { state: BatchesTabsEnumStrings, t: TranslateFunction }) => {
    let bgColor = '';
    let textColor = '';
    const label = getBatchStateLabel(state, t);

    switch (state) {
        case BatchesTabsEnumStrings.PENDIENTE:
            bgColor = '#fef3c7';   // marrón claro
            textColor = '#92400e';
            break;
        case BatchesTabsEnumStrings.EN_CURSO:
            bgColor = '#e0f2fe';   // celeste
            textColor = '#075985';
            break;
        case BatchesTabsEnumStrings.CERRADO:
            bgColor = '#dcfce7';   // verde
            textColor = '#166534';
            break;
        default:
            bgColor = '#F5F5F5';
            textColor = '#9E9E9E';
            break;
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: bgColor,
                padding: '4px 12px',
                borderRadius: '16px',
                fontWeight: 600,
                color: textColor,
                fontSize: '0.875rem',
                textTransform: 'capitalize'
            }}
        >
            {label}
        </Box>
    );
};
